import {
  CartesianGrid,
  ResponsiveContainer,
  Scatter,
  ScatterChart,
  Tooltip,
  XAxis,
  YAxis,
  ZAxis,
} from 'recharts'

import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card'
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '@/components/ui/table'
import type { Accuracy } from '@/models/quoteAnalytics'

const pct = (n: number) => `${(n * 100).toFixed(1)}%`

export function AccuracyTab({ accuracy }: { accuracy: Accuracy }) {
  if (accuracy.sampleSize === 0) {
    return (
      <div className="p-8 text-neutral-500">
        No applications with both a persisted estimate and a real offer in this range.
      </div>
    )
  }
  return (
    <div className="flex flex-col gap-6 pt-4">
      <div className="text-sm text-neutral-500">
        Sample: {accuracy.sampleSize} paired offers · within estimate range {pct(accuracy.withinRangeRate)} ·
        median variance {accuracy.medianVariancePct}%
      </div>
      <Card>
        <CardHeader>
          <CardTitle>Estimate (mid) vs actual per-unit premium</CardTitle>
        </CardHeader>
        <CardContent>
          <ResponsiveContainer width="100%" height={360}>
            <ScatterChart>
              <CartesianGrid />
              <XAxis type="number" dataKey="estimateMid" name="Estimate" unit="$" />
              <YAxis type="number" dataKey="actual" name="Actual" unit="$" />
              <ZAxis range={[60, 60]} />
              <Tooltip cursor={{ strokeDasharray: '3 3' }} />
              <Scatter data={accuracy.points} fill="#6366f1" />
            </ScatterChart>
          </ResponsiveContainer>
        </CardContent>
      </Card>
      <Card>
        <CardHeader>
          <CardTitle>Accuracy by vendor</CardTitle>
        </CardHeader>
        <CardContent>
          <Table>
            <TableHeader>
              <TableRow>
                <TableHead>Vendor</TableHead>
                <TableHead className="text-right">Sample</TableHead>
                <TableHead className="text-right">Within range</TableHead>
                <TableHead className="text-right">Median variance</TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {accuracy.byVendor.map((r) => (
                <TableRow key={r.vendor}>
                  <TableCell>{r.vendor}</TableCell>
                  <TableCell className="text-right">{r.sampleSize}</TableCell>
                  <TableCell className="text-right">{pct(r.withinRangeRate)}</TableCell>
                  <TableCell className="text-right">{r.medianVariancePct}%</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </CardContent>
      </Card>
    </div>
  )
}
